module.exports = __webpack_public_path__ + "img/logo.f988d8e8.gif";